import { render, staticRenderFns } from "./TaskCreateStrictModeItem.component.vue?vue&type=template&id=45946383&scoped=true&"
import script from "./TaskCreateStrictModeItem.component.vue?vue&type=script&lang=js&"
export * from "./TaskCreateStrictModeItem.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45946383",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VFlex,VIcon,VLayout,VTooltip})
